import { useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Cookies from 'js-cookie';
import {PasswordField, Submit} from './Fields.js';


export function ChangePassword({onSuccess}){
	const [password, setPassword] = useState("");
	const [password1, setPassword1] = useState("");
	const [password2, setPassword2] = useState("");
	const [error, setError] = useState({});
	async function onSubmit(){
		let formData = new FormData();
		formData.append("password", password);
		formData.append("password1", password1);
		formData.append("password2", password2);
		let response = await fetch("/accounts/api/change_password/", {
			method: "POST",
			headers: {
				"X-csrftoken": Cookies.get("csrftoken"),
			},
			body: formData,
		});
		if(!response.ok){
			setError(await response.json());
		}else{
			setError({})
			onSuccess();
		}
	}
	return (
		<Container maxWidth="sm">
			<Box component="form">
				<PasswordField setField={setPassword} error={error} id="password"/>
				<PasswordField setField={setPassword1} error={error} id="password1" name="New password"/>
				<PasswordField setField={setPassword2} error={error} id="password2" name="New password confirmation"/>
				<Submit onSubmit={onSubmit} error={error} name="Change your password"/>
			</Box>
		</Container>
	)
}
